import { Injectable, inject } from '@angular/core';
import {
  ArtistInfoResult,
  GetArtistByDescriptorDocument,
  GetArtistByDescriptorQueryVariables,
} from '@shared/graphql/api.generated';
import { GraphqlClients, GraphqlService } from '@shared/graphql/graphql.service';

@Injectable()
export class ArtistService {
  private readonly graphqlService = inject(GraphqlService);

  getArtistByDescriptor(descriptor: string) {
    return this.graphqlService.makeQuery<ArtistInfoResult, GetArtistByDescriptorQueryVariables>(
      GraphqlClients.api,
      GetArtistByDescriptorDocument,
      {
        descriptor,
      },
    );
  }
}
